import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import aiAgentImage from "@/assets/login_bg/ai-agent-logo.webp";

export const AiAgentImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[aiAgentImage]}
      {...props}
    />
  );
};

AiAgentImage.displayName = 'AiAgentImage';
